import { CHANNEL_ID } from "./const";
import {CHAT_TYPE_DIRECT,CHAT_TYPE_GROUP,CHAT_TYPE_CHANNEL,ChatType, teamsParseChatId} from "./chat_base"
import { createTuituiClient } from "./sdk";
import {
  type GetChatRecordOptions,
  type TuituiChatRecordResponse,
  type TuituiCompactChatRecordResponse,
} from "@qihoo/tuitui-bot-sdk";

export async function getChatRecord(
  account: any,
  chatId: string,
  chatType: ChatType,
  options: GetChatRecordOptions = {},
): Promise<TuituiChatRecordResponse | TuituiCompactChatRecordResponse> {
  if (chatType == CHAT_TYPE_CHANNEL) {
    const channelId = chatId.startsWith("teams_")
      ? teamsParseChatId(chatId).channel_id
      : chatId;
    const ret = await createTuituiClient(account).teams.getChannelPosts(channelId, options);
    console.log(`[${CHANNEL_ID}] getChatRecord(channel) result: ${(ret.threads ?? []).length} threads, has_more=${ret.has_more}, cursor=${ret.cursor}`);
    return ret;
  }
  if (chatType != CHAT_TYPE_DIRECT && chatType != CHAT_TYPE_GROUP) {
    throw new Error(`[${CHANNEL_ID}] getChatRecord: chatType "${chatType}" is not supported`);
  }

  const client = createTuituiClient(account);
  const clean = await (chatType == CHAT_TYPE_DIRECT
    ? client.im.getHistory(client.to.account(chatId), { ...options, compactForAgent: true })
    : client.im.getHistory(client.to.group(chatId), { ...options, compactForAgent: true })) as TuituiCompactChatRecordResponse;

  console.log(`[${CHANNEL_ID}] getChatRecord result(cleaned)`, JSON.stringify(clean, null, 2));

  return clean;
}
